import { ref } from 'vue';

const isInScrollJackSection = ref(false);

export function useScrollJackSection() {
  const setInScrollJackSection = (value) => {
    isInScrollJackSection.value = value;
  };

  return {
    isInScrollJackSection,
    setInScrollJackSection,
  };
}
